import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  ListItemIcon,
  IconButton,
  Divider,
} from "@mui/material";
import {
  DashboardOutlined,
  MenuBookOutlined,
  AccountCircleOutlined,
  GradeOutlined,
  ExitToAppOutlined,
} from "@mui/icons-material";
import { styled } from "@mui/system";
import { alpha } from "@mui/material/styles";

const LogoutButton = styled(IconButton)(({ theme }) => ({
  color: theme?.palette?.error?.main || "#2570e7",
  textTransform: "none",
  "&:hover": {
    backgroundColor: alpha(theme?.palette?.error?.main || "#2570e7", 0.08),
  },
}));

const handleLogout = () => {
  localStorage.clear();
  window.location.reload();
};

const drawerWidth = 210;

const LeftSidebar = ({ currentScreen, setCurrentScreen }) => {
  return (
    <div style={{ display: "flex" }}>
      {/* Sidebar / Drawer */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            bgcolor: "#fff",
            color: "#2570e7",
            border: "none",
            padding: "0px 15px",
            transition: "0.3s",
          },
        }}
      >
        {/* Logo */}
        <Box sx={{ textAlign: "center", marginBottom: 3, marginTop: 5 }}>
          <img
            src={require("../assets/coloredLogo.png")}
            alt="Logo"
            style={{ height: 50, marginBottom: 15, width: 150, marginTop: -23 }}
          />
        </Box>

        {/* Sidebar Items */}

        <List>
          {/* Dashboard */}
          <ListItem
            button
            onClick={() => setCurrentScreen(10)}
            selected={currentScreen === 10}
            sx={{
              "&.Mui-selected, &:hover": {
                bgcolor: "#2570e7",
                color: "white",
                borderRadius: "3px",
              },
              "&:hover": { bgcolor: "#3788d8e8" },
              mb: 2,
              p: 1.2,
              borderRadius: "3px",
            }}
          >
            <ListItemIcon sx={{ color: "#0f4a98", minWidth: 36 }}>
              <DashboardOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Dashboard"
              primaryTypographyProps={{
                fontSize: 13,
                sx: { "&:hover": { color: "#0f4a98" } },
              }}
            />
          </ListItem>

          {/* Courses */}
          <ListItem
            button
            onClick={() => setCurrentScreen(0)}
            selected={currentScreen === 0}
            sx={{
              "&.Mui-selected, &:hover": {
                bgcolor: "#2570e7",
                color: "white",
                borderRadius: "3px",
              },
              "&:hover": { bgcolor: "#3788d8e8" },
              mb: 2,
              p: 1.2,
              borderRadius: "3px",
            }}
          >
            <ListItemIcon sx={{ color: "#0f4a98", minWidth: 36 }}>
              <MenuBookOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Courses"
              primaryTypographyProps={{
                fontSize: 13,
                sx: { "&:hover": { color: "#0f4a98" } },
              }}
            />
          </ListItem>

          {/* Grades */}
          <ListItem
            button
            onClick={() => setCurrentScreen(8)}
            selected={currentScreen === 8}
            sx={{
              "&.Mui-selected, &:hover": {
                bgcolor: "#2570e7",
                color: "white",
                borderRadius: "3px",
              },
              "&:hover": { bgcolor: "#3788d8e8" },
              mb: 2,
              p: 1.2,
              borderRadius: "3px",
            }}
          >
            <ListItemIcon sx={{ color: "#0f4a98", minWidth: 36 }}>
              <GradeOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Grades"
              primaryTypographyProps={{
                fontSize: 13,
                sx: { "&:hover": { color: "#0f4a98" } },
              }}
            />
          </ListItem>

          {/* Profile */}
          <ListItem
            button
            onClick={() => setCurrentScreen(7)}
            selected={currentScreen === 7}
            sx={{
              "&.Mui-selected, &:hover": {
                bgcolor: "#2570e7",
                color: "white",
                borderRadius: "3px",
              },
              "&:hover": { bgcolor: "#3788d8e8" },
              mb: 2,
              p: 1.2,
              borderRadius: "3px",
            }}
          >
            <ListItemIcon sx={{ color: "#0f4a98", minWidth: 36 }}>
              <AccountCircleOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary="Profile"
              primaryTypographyProps={{
                fontSize: 13,
                sx: { "&:hover": { color: "#0f4a98" } },
              }}
            />
          </ListItem>
        </List>

        <Divider sx={{ my: 2, bgcolor: "#2570e7" }} />

        {/* Logout Button */}
        <Box sx={{ textAlign: "center" }}>
          <LogoutButton
            onClick={handleLogout}
            sx={{
              width: "100%",
              py: 1.5,
              borderRadius: 2,
              color: "#2570e7",
            }}
          >
            <ExitToAppOutlined fontSize="small" sx={{ mr: 1 }} />
            Logout
          </LogoutButton>
        </Box>
      </Drawer>
    </div>
  );
};

export default LeftSidebar;
